export const name = "ST_ISEMPTY";
export const summary = `Checks if a \`GEOGRAPHY\` value is empty.`;
export const reference = `
## ST_ISEMPTY

Checks if a \`GEOGRAPHY\` value is empty.

\`\`\`
ST_ISEMPTY(geography_expression)
\`\`\`

### Description

Returns \`TRUE\` if the given \`GEOGRAPHY\` is empty; that is, the \`GEOGRAPHY\`doesn't contain any points, lines, or polygons.

NOTE: An empty \`GEOGRAPHY\` isn't associated with a particular geometry shape. For example, the results of expressions \`ST_GEOGFROMTEXT('POINT EMPTY')\` and\`ST_GEOGFROMTEXT('GEOMETRYCOLLECTION EMPTY')\` are identical.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
